import { render, staticRenderFns } from "./exam-registed.vue?vue&type=template&id=66d51e16&scoped=true&"
import script from "./exam-registed.vue?vue&type=script&lang=js&"
export * from "./exam-registed.vue?vue&type=script&lang=js&"
import style0 from "./exam-registed.vue?vue&type=style&index=0&id=66d51e16&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d51e16",
  null
  
)

export default component.exports